var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0c-6.62891,0 -12,5.37109 -12,12c0,6.62891 5.37109,12 12,12c6.62891,0 12,-5.37109 12,-12c0,-6.62891 -5.37109,-12 -12,-12zM12,2c5.52344,0 10,4.47656 10,10c0,5.52344 -4.47656,10 -10,10c-5.52344,0 -10,-4.47656 -10,-10c0,-5.52344 4.47656,-10 10,-10zM12,5.8125c-0.18359,0 -0.33594,-0.00391 -0.5,0.03125c-0.16406,0.03516 -0.31641,0.125 -0.4375,0.21875c-0.12109,0.09375 -0.21094,0.22266 -0.28125,0.375c-0.07031,0.15234 -0.09375,0.33203 -0.09375,0.5625c0,0.22656 0.02344,0.40625 0.09375,0.5625c0.07031,0.15625 0.16016,0.28125 0.28125,0.375c0.12109,0.09375 0.27344,0.14844 0.4375,0.1875c0.16406,0.03906 0.31641,0.0625 0.5,0.0625c0.17969,0 0.37109,-0.02344 0.53125,-0.0625c0.16016,-0.03906 0.28516,-0.09375 0.40625,-0.1875c0.12109,-0.09375 0.21094,-0.21875 0.28125,-0.375c0.07031,-0.15234 0.125,-0.33594 0.125,-0.5625c0,-0.23047 -0.05469,-0.41016 -0.125,-0.5625c-0.07031,-0.15234 -0.16016,-0.28125 -0.28125,-0.375c-0.12109,-0.09375 -0.24609,-0.18359 -0.40625,-0.21875c-0.16016,-0.03516 -0.35156,-0.03125 -0.53125,-0.03125zM10.78125,9.15625v8.96875h2.4375v-8.96875z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoiconwhite);
export default __webpack_public_path__ + "static/media/infoiconwhite.89ce4ac0e61e1a897fd47e45230fd3da.svg";
export { ForwardRef as ReactComponent };